import { faTable } from '@fortawesome/pro-regular-svg-icons/faTable';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { Group } from './group';
import { DataSourceProperty } from '../../properties-panel/widget-properties/data-source/data-source';
import { HeightProperty } from '../../properties-panel/widget-properties/height-input/height-input';
import { WidthProperty } from '../../properties-panel/widget-properties/width-input/width-input';
import { WIDGET_TYPE } from '../widget-type';

import type { RowWidget, RowWidgetDefinition, WidgetConfig, WidgetProperties, WidgetProps } from '../../config';

const rowDefinition: RowWidgetDefinition = {
  type: WIDGET_TYPE.row,
  ui: {
    label: 'Row',
    pickerElement: <FontAwesomeIcon icon={faTable} />,
    supportedNestedTypes: [WIDGET_TYPE.text, WIDGET_TYPE.line, WIDGET_TYPE.barcode],
    isBuiltInTemplate: true,
  },
  initialConfiguration: {
    height: 60,
    dataSource: '.items',
  },
};

const rowProperties: WidgetProperties<RowWidget> = [WidthProperty, HeightProperty, DataSourceProperty];

const Row = ({ widget, components }: WidgetProps<RowWidget>) => {
  return <Group components={components} parentWidget={widget} supportedNestedTypes={rowDefinition.ui.supportedNestedTypes} />;
};

export const RowWidgetConfig: WidgetConfig<RowWidget> = {
  Component: Row,
  definition: rowDefinition,
  properties: rowProperties,
};
